import React from 'react';
import {
  Section,
  SectionContent,
  SectionTitle,
  SectionSubtitle,
  SectionDescription,
  WhatWeDoGrid,
  WhatWeDoItem,
  WhatWeDoImage,
  WhatWeDoTextOverlay,
} from '../styles/sections';
import { IntroCopy, MarqueeWrapper, MarqueeTrack, ClubLogo } from '../styles/marquee';
import { clubs } from '../data/clubs';

// Duplicated so the track can loop seamlessly at a -50% translate.
const marqueeClubs = [...clubs, ...clubs];

function WhatWeDoSection() {
  const whatWeDoItems = [
    { image: '/rugby-game.jpg', text: 'Keep your team on schedule with automated reminders.' },
    { image: '/american-football.jpg', text: 'Effortlessly log and manage team fines with real-time updates.' },
    { image: '/image2.jpg', text: 'Safe and easy payment collection for fines and fees.' },
  ];

  return (
    <Section id="what-we-do" backgroundColor="#000" style={{ paddingTop: '3.5rem' }}>
      <SectionContent>
        <IntroCopy>
          Join thousands of club admins, members, parents and team leaders across 200+
          clubs
        </IntroCopy>
      </SectionContent>

      <MarqueeWrapper>
        <MarqueeTrack>
          {marqueeClubs.map((club, index) => (
            <ClubLogo key={`${club}-${index}`} src={club} alt="Club logo" loading="lazy" />
          ))}
        </MarqueeTrack>
      </MarqueeWrapper>

      <SectionContent>
        <SectionSubtitle style={{ color: '#fff' }}>Discover Our Tools</SectionSubtitle>
        <SectionTitle style={{ color: '#fff' }}>What We Do</SectionTitle>
        <SectionDescription style={{ color: '#fff' }}>
          Playfair offers a suite of tools to enhance your sports team's management and morale.
        </SectionDescription>
        <WhatWeDoGrid>
          {whatWeDoItems.map((item, index) => (
            <WhatWeDoItem key={index} whileHover={{ y: -5 }}>
              <WhatWeDoImage style={{ backgroundImage: `url(${item.image})` }}>
                <WhatWeDoTextOverlay>{item.text}</WhatWeDoTextOverlay>
              </WhatWeDoImage>
            </WhatWeDoItem>
          ))}
        </WhatWeDoGrid>
      </SectionContent>
    </Section>
  );
}

export default WhatWeDoSection;
